import React from 'react';

export const MinusCircleFilledIcon = () => {
	return (
		<svg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
			<path d='M15.9998 2.6665C8.6665 2.6665 2.6665 8.6665 2.6665 15.9998C2.6665 23.3332 8.6665 29.3332 15.9998 29.3332C23.3332 29.3332 29.3332 23.3332 29.3332 15.9998C29.3332 8.6665 23.3332 2.6665 15.9998 2.6665ZM21.3332 17.3332C20.2665 17.3332 17.3332 17.3332 17.3332 17.3332C17.3332 17.3332 16.7998 17.3332 15.9998 17.3332C15.1998 17.3332 14.6665 17.3332 14.6665 17.3332C14.6665 17.3332 11.7332 17.3332 10.6665 17.3332C9.8665 17.3332 9.33317 16.7998 9.33317 15.9998C9.33317 15.1998 9.8665 14.6665 10.6665 14.6665C11.7332 14.6665 14.6665 14.6665 14.6665 14.6665C14.6665 14.6665 15.1998 14.6665 15.9998 14.6665C16.7998 14.6665 17.3332 14.6665 17.3332 14.6665C17.3332 14.6665 20.2665 14.6665 21.3332 14.6665C22.1332 14.6665 22.6665 15.1998 22.6665 15.9998C22.6665 16.7998 22.1332 17.3332 21.3332 17.3332Z' />
		</svg>
	);
};

export default MinusCircleFilledIcon;
